import fetch from "isomorphic-fetch";
import loadImage from "blueimp-load-image";
import { updateUser, updatingUser } from "./users";
import { openSnackBar } from "./snack-bar";
import { API } from "../store";
import constants from "../config/constant";

export const addingLicensePhoto = (addingLicensePhoto = true) => ({
  type: "CLIENT::ADDING_LICENSE",
  addingLicensePhoto
});

export const sendPhotoID = (data, id) => (dispatch, getState) => {
  API.put(`/users/${id}/license`)
    .send({ photo_id: data })
    .then(res => {
      console.log(res, "res");
      if (!res.ok) {
        throw Error(res.statusText);
      }
      dispatch(
        openSnackBar({
          message: constants.MESSAGE.LICENCE_SUCCESS
        })
      );
      return res.body;
    })
    .catch(message => {
      dispatch(
        openSnackBar({
          message
        })
      );
    });
};

export const sendAvatar = (data, dispatch, id) => {
  const { public_id, format, secure_url, version, width } = data;

  const avatar = {
    avatar: JSON.stringify({
      public_id,
      format,
      secure_url,
      version,
      width
    })
  };
  dispatch(updateUser(id, avatar));
};

export const uploadImage = (img1, photoType, callback) => (
  dispatch,
  getState
) => {
  if (constants.PROFILE_IMAGE_MIME.indexOf(img1.type) > -1) {
    // img = fileSizeReducer(img)
    dispatch(updatingUser());

    loadImage(
      img1,
      img => {
        const cloudName =
          process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || "safeshowings";
        // const signedName = 'pvm4ybzq' || process.env.REACT_APP_CLOUDINARY_SIGNED_NAME
        const unsignedName =
          "hqabdoeu" || process.env.REACT_APP_CLOUDINARY_UNSIGNED_NAME;

        const newCanvas = document.createElement("canvas");

        var MAX_WIDTH = 1500;
        var MAX_HEIGHT = 1500;
        var tempW = img.width;
        var tempH = img.height;
        if (tempW > tempH) {
          if (tempW > MAX_WIDTH) {
            tempH *= MAX_WIDTH / tempW;
            tempW = MAX_WIDTH;
          }
        } else {
          if (tempH > MAX_HEIGHT) {
            tempW *= MAX_HEIGHT / tempH;
            tempH = MAX_HEIGHT;
          }
        }

        const newCtx = newCanvas.getContext("2d");
        newCanvas.width = tempW;
        newCanvas.height = tempH;
        newCtx.drawImage(img, 0, 0, tempW, tempH);

        // img.width = tempW
        // img.height = tempH
        // var ctx = img.getContext('2d')
        // ctx.drawImage(img, 0, 0, tempW, tempH)
        var dataURL = newCanvas.toDataURL("image/jpeg");
        const formData = new FormData();

        formData.append("file", dataURL); //img.toDataURL('image/jpg')) // fileSizeReducer(img))
        formData.append(
          "upload_preset",
          photoType === "avatar" ? unsignedName : unsignedName //signedName
        ); // ! TODO signed upload CHECK
        formData.append("signUrl", "true");
        formData.append("secure", "true");
        fetch(`https://api.cloudinary.com/v1_1/${cloudName}/upload`, {
          method: "post",
          body: formData
        })
          .then(res => res.json())
          .then(data => {
            if (data.secure_url) {
              const myID = getState().authentication.authenticatedUser.id;
              if (photoType === "avatar") {
                sendAvatar(data, dispatch, myID);
              } else {
                const { public_id, format, secure_url, version, width } = data;

                const photo_id = {
                  photo_id: JSON.stringify({
                    public_id,
                    format,
                    secure_url,
                    version,
                    width
                  })
                };

                callback(photo_id);
                // dispatch(sendPhotoID(data, dispatch, myID, callback))
              }
            } else {
              throw Error(data.statusText);
            }
            dispatch(updatingUser(false));
          })
          .catch(err => {
            dispatch(
              openSnackBar({
                message:
                  constants.MESSAGE.UPLOAD_ERROR
              })
            );
            dispatch(updatingUser(false));
            // callback('')
          });
      },
      { orientation: true, crossOrigin: "anonymous" }
    );
  } else {
    dispatch(updatingUser(false));
    dispatch(
      openSnackBar({
        message: constants.MESSAGE.UNSUPPORTED_FILE
      })
    );
  }
};

// const imageResizer = imgFile => {
//   // var filesToUpload = input.files;
//   var file = imgFile

//   var img = document.createElement('img')
//   var reader = new FileReader()
//   reader.onload = function(e) {
//     img.src = e.target.result
//   }
//   reader.readAsDataURL(file)

//   var ctx = canvas.getContext('2d')
//   ctx.drawImage(img, 0, 0)

//   var MAX_WIDTH = 800
//   var MAX_HEIGHT = 600
//   var width = img.width
//   var height = img.height

//   if (width > height) {
//     if (width > MAX_WIDTH) {
//       height *= MAX_WIDTH / width
//       width = MAX_WIDTH
//     }
//   } else {
//     if (height > MAX_HEIGHT) {
//       width *= MAX_HEIGHT / height
//       height = MAX_HEIGHT
//     }
//   }
//   canvas.width = width
//   canvas.height = height
//   var ctx = canvas.getContext('2d')
//   ctx.drawImage(img, 0, 0, width, height)

//   var dataurl = canvas.toDataURL('image/png')

// }

//Post dataurl to the server with AJAX
